var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcGuestContent',[_c('h2',[_vm._v(_vm._s(_vm.t('mail', 'Account connected')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.t('mail', 'You can close this window')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }